/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Misc_Discordlinked_Title1Inputs */

const id_misc_discordlinked_title1 = /** @type {(inputs: Misc_Discordlinked_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akun Berhasil Ditautkan!`)
};

const ms_misc_discordlinked_title1 = /** @type {(inputs: Misc_Discordlinked_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akaun Berjaya Dipautkan!`)
};

const da_misc_discordlinked_title1 = /** @type {(inputs: Misc_Discordlinked_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konto Linket Succesfuldt!`)
};

const de_misc_discordlinked_title1 = /** @type {(inputs: Misc_Discordlinked_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konto erfolgreich verknüpft!`)
};

const en_us2_misc_discordlinked_title1 = /** @type {(inputs: Misc_Discordlinked_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Account Linked Successfully!`)
};

const es_es2_misc_discordlinked_title1 = /** @type {(inputs: Misc_Discordlinked_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Cuenta vinculada correctamente!`)
};

const es_mx2_misc_discordlinked_title1 = /** @type {(inputs: Misc_Discordlinked_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Cuenta vinculada exitosamente!`)
};

const fil_misc_discordlinked_title1 = /** @type {(inputs: Misc_Discordlinked_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Matagumpay na Na-link ang Account!`)
};

const fr_misc_discordlinked_title1 = /** @type {(inputs: Misc_Discordlinked_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compte lié avec succès !`)
};

const it_misc_discordlinked_title1 = /** @type {(inputs: Misc_Discordlinked_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Account collegato con successo!`)
};

const hu_misc_discordlinked_title1 = /** @type {(inputs: Misc_Discordlinked_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fiók sikeresen összekapcsolva!`)
};

const nl_misc_discordlinked_title1 = /** @type {(inputs: Misc_Discordlinked_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Account succesvol gekoppeld!`)
};

const no_misc_discordlinked_title1 = /** @type {(inputs: Misc_Discordlinked_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konto koblet til!`)
};

const pl_misc_discordlinked_title1 = /** @type {(inputs: Misc_Discordlinked_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konto połączone pomyślnie!`)
};

const pt_br2_misc_discordlinked_title1 = /** @type {(inputs: Misc_Discordlinked_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conta vinculada com sucesso!`)
};

const pt_misc_discordlinked_title1 = /** @type {(inputs: Misc_Discordlinked_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conta vinculada com sucesso!`)
};

const ro_misc_discordlinked_title1 = /** @type {(inputs: Misc_Discordlinked_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cont asociat cu succes!`)
};

const fi_misc_discordlinked_title1 = /** @type {(inputs: Misc_Discordlinked_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tili linkitetty onnistuneesti!`)
};

const sv_misc_discordlinked_title1 = /** @type {(inputs: Misc_Discordlinked_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konto länkat!`)
};

const vi_misc_discordlinked_title1 = /** @type {(inputs: Misc_Discordlinked_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liên kết tài khoản thành công!`)
};

const tr_misc_discordlinked_title1 = /** @type {(inputs: Misc_Discordlinked_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hesap Başarıyla Bağlandı!`)
};

const cs_misc_discordlinked_title1 = /** @type {(inputs: Misc_Discordlinked_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Účet úspěšně propojen!`)
};

const bg_misc_discordlinked_title1 = /** @type {(inputs: Misc_Discordlinked_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Акаунтът е свързан успешно!`)
};

const ru_misc_discordlinked_title1 = /** @type {(inputs: Misc_Discordlinked_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Учётная запись успешно привязана!`)
};

const uk_misc_discordlinked_title1 = /** @type {(inputs: Misc_Discordlinked_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обліковий запис успішно прив'язано!`)
};

const ar_misc_discordlinked_title1 = /** @type {(inputs: Misc_Discordlinked_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تم ربط الحساب بنجاح!`)
};

const hi_misc_discordlinked_title1 = /** @type {(inputs: Misc_Discordlinked_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`खाता सफलतापूर्वक लिंक किया गया!`)
};

const th_misc_discordlinked_title1 = /** @type {(inputs: Misc_Discordlinked_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เชื่อมต่อบัญชีสำเร็จ!`)
};

const ja_misc_discordlinked_title1 = /** @type {(inputs: Misc_Discordlinked_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アカウントの連携に成功しました！`)
};

const zh_cn2_misc_discordlinked_title1 = /** @type {(inputs: Misc_Discordlinked_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`账号关联成功！`)
};

const zh_hant1_misc_discordlinked_title1 = /** @type {(inputs: Misc_Discordlinked_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`帳號關聯成功！`)
};

const ko_misc_discordlinked_title1 = /** @type {(inputs: Misc_Discordlinked_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`계정이 성공적으로 연결되었습니다!`)
};

/**
* | output |
* | --- |
* | "Account Linked Successfully!" |
*
* @param {Misc_Discordlinked_Title1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const misc_discordlinked_title1 = /** @type {((inputs?: Misc_Discordlinked_Title1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Misc_Discordlinked_Title1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_misc_discordlinked_title1(inputs)
	if (locale === "ms") return ms_misc_discordlinked_title1(inputs)
	if (locale === "da") return da_misc_discordlinked_title1(inputs)
	if (locale === "de") return de_misc_discordlinked_title1(inputs)
	if (locale === "en-US") return en_us2_misc_discordlinked_title1(inputs)
	if (locale === "es-ES") return es_es2_misc_discordlinked_title1(inputs)
	if (locale === "es-MX") return es_mx2_misc_discordlinked_title1(inputs)
	if (locale === "fil") return fil_misc_discordlinked_title1(inputs)
	if (locale === "fr") return fr_misc_discordlinked_title1(inputs)
	if (locale === "it") return it_misc_discordlinked_title1(inputs)
	if (locale === "hu") return hu_misc_discordlinked_title1(inputs)
	if (locale === "nl") return nl_misc_discordlinked_title1(inputs)
	if (locale === "no") return no_misc_discordlinked_title1(inputs)
	if (locale === "pl") return pl_misc_discordlinked_title1(inputs)
	if (locale === "pt-BR") return pt_br2_misc_discordlinked_title1(inputs)
	if (locale === "pt") return pt_misc_discordlinked_title1(inputs)
	if (locale === "ro") return ro_misc_discordlinked_title1(inputs)
	if (locale === "fi") return fi_misc_discordlinked_title1(inputs)
	if (locale === "sv") return sv_misc_discordlinked_title1(inputs)
	if (locale === "vi") return vi_misc_discordlinked_title1(inputs)
	if (locale === "tr") return tr_misc_discordlinked_title1(inputs)
	if (locale === "cs") return cs_misc_discordlinked_title1(inputs)
	if (locale === "bg") return bg_misc_discordlinked_title1(inputs)
	if (locale === "ru") return ru_misc_discordlinked_title1(inputs)
	if (locale === "uk") return uk_misc_discordlinked_title1(inputs)
	if (locale === "ar") return ar_misc_discordlinked_title1(inputs)
	if (locale === "hi") return hi_misc_discordlinked_title1(inputs)
	if (locale === "th") return th_misc_discordlinked_title1(inputs)
	if (locale === "ja") return ja_misc_discordlinked_title1(inputs)
	if (locale === "zh-CN") return zh_cn2_misc_discordlinked_title1(inputs)
	if (locale === "zh-Hant") return zh_hant1_misc_discordlinked_title1(inputs)
	return ko_misc_discordlinked_title1(inputs)
});
export { misc_discordlinked_title1 as "misc.discordLinked.title" }